/**
 * Mirrors resolveTestMode on the API, which stays authoritative. This only
 * decides what the browser shows and which Stripe key it loads. The upsell hint
 * is a browser cookie, so it is display-only. See spec §3/§3a.
 */
export function hasTestPaymentsIntent(query = {}) {
  const value = query.testingPayments;

  return value === true || value === 'true';
}

export default function getIsTestMode({
  query = {},
  page = {},
  upsell = null,
  isOwner = false,
} = {}) {
  if (page?.testmode === true) {
    return true;
  }

  if (upsell?.livemode === false) {
    return true;
  }

  return hasTestPaymentsIntent(query) && isOwner === true;
}
